var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchTopBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M897.61 86.15L813.84 2.39c-5.11-5.11-13.85-1.49-13.85 5.73v27.87H32C14.4 36 0 50.4 0 68c0 17.6 14.4 32 32 32h859.87c7.23 0 10.84-8.74 5.73-13.85h.01z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v100H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTopBackground);
export default __webpack_public_path__ + "static/media/search_top_background.caef515b17e69c4d72835112fc323ead.svg";
export { ForwardRef as ReactComponent };